import { useState, useEffect } from 'react';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import ImageUploading from 'react-images-uploading';
import Refreshing from '../components/Refreshing';

import { MdOutlineAddPhotoAlternate } from "react-icons/md";

import ImageCropModal from '../modals/ImageCropModal';

import * as dayjs from 'dayjs'

import * as apiComms from '../apiComms';

const WebstoreLinkAddOrEditModal = (props) => {

  const [ webstoreLinkName, setWebstoreLinkName ] = useState('');
  const [ webstoreLinkDisplayText, setWebstoreLinkDisplayText ] = useState('');
  const [ webstoreLinkLinkUrl, setWebstoreLinkLinkUrl ] = useState(global.DEFAULT_NEW_PROMOTION_LINK_URL);
  const [ displayFrom, setDisplayFrom ] = useState(new Date());
  const [ displayTo, setDisplayTo ] = useState(new Date());
  const [ images, setImages ] = useState([]);
  const [ isRefreshingView, setIsRefreshingView ] = useState(props.isRefreshing);
  const [ refreshingMessage, setRefreshingMessage ] = useState('Refreshing...');
  const [ isImageCropModalVisible, setIsImageCropModalVisible ] = useState(false);
  const [ cropImage, setCropImage ] = useState(null);
  const [ isPreloadedImage, setIsPreloadedImage ] = useState(false);
  const [ windowHeight, setWindowHeight ] = useState(100);

  useEffect(() => {

    setWindowHeight(window.innerHeight);

    if (props.hasOwnProperty('existingWebstoreLink')) {
      const existingItem = props.existingWebstoreLink;

      setWebstoreLinkName(existingItem.title);
      setWebstoreLinkLinkUrl(existingItem.callToActionUrl);

      if (existingItem.hasOwnProperty('displayText')) {
        setWebstoreLinkDisplayText(existingItem.displayText);
      }

      let _displayFrom = dayjs(existingItem.displayFrom*1000);
      setDisplayFrom(_displayFrom.toDate());

      let _displayTo = dayjs(existingItem.displayTo*1000);
      setDisplayTo(_displayTo.toDate());

      //const img = await getImage(existingItem.imageUrl);

      loadImage(existingItem.imageUrl);

      //setImages([ img ]);
    }
    else {
      const now = new Date();
      setDisplayFrom(now); // Today
      let threeMonthsFromNow = new Date();
      threeMonthsFromNow.setDate(now.getDate()+90);
      setDisplayTo(threeMonthsFromNow);
    }
  }, []);

  const loadImage = async (imgUrl) => {
    setImages([ imgUrl ]);
    
    const m = /^.*\/(.*?\.png)$/.exec(imgUrl);
    if (m) {
      const imageWithoutDirectoryPrefix = m[1];
      const res = await apiComms.getImage(imageWithoutDirectoryPrefix);
      console.log(1);
      if (res.isErr) {
        alert('Error loading Image: '+res.errMsg);
      }
      else {
        const base64Image = res.response.image;
        const base64ImageWithHeader = 'data:image/png;base64,'+base64Image;
        setImages( [ { data_url : base64ImageWithHeader } ] );
        setIsPreloadedImage(true);
      }
    }
  };



  const onImageChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
    setIsPreloadedImage(false);
  };

  const handleSubmitButtonPress = async () => {
    if (!isPreloadedImage) {
      // We need to process and crop the image
      setRefreshingMessage('Uploading Image...');
      setIsRefreshingView(true);
      const imageObject = images[0];
      const image_data = imageObject.data_url;
      setIsRefreshingView(false);
      setCropImage(image_data);
      setIsImageCropModalVisible(true);
    }
    else {
      // Image was already previously cropped and
      // loaded so no cropping required

      let webstoreLinkId = null;
      if (props.existingWebstoreLink.hasOwnProperty('linkId')) {
        webstoreLinkId = props.existingWebstoreLink.linkId;
      }
      else if (props.existingWebstoreLink.hasOwnProperty('couponId')) {
        webstoreLinkId = props.existingWebstoreLink.couponId;
      }
      const webstoreLinkItem = {
        linkId : webstoreLinkId,
        title : webstoreLinkName,
        displayText : webstoreLinkDisplayText,
        linkUrl : webstoreLinkLinkUrl,
        imageUrl : props.existingWebstoreLink.imageUrl,
        displayFrom : (displayFrom.getTime() / 1000),
        displayTo : (displayTo.getTime() / 1000)
      };
      props.handleSubmitButtonPress(webstoreLinkItem);
    }
  };

  const handleSubmitImageCropCompletedEvent = async (croppedImageUrl) => {
    const FUNCTION = 'handleAddNewImageCropCompletedEvent';

    // Hide the Crop-Image Modal
    setIsImageCropModalVisible(false);

    let webstoreLinkItem = {
      title : webstoreLinkName,
      displayText : webstoreLinkDisplayText,
      linkUrl : webstoreLinkLinkUrl,
      imageUrl : croppedImageUrl,
      displayFrom : (displayFrom.getTime() / 1000),
      displayTo : (displayTo.getTime() / 1000)
    };
    if (props.hasOwnProperty('existingWebstoreLink') && props.existingWebstoreLink.hasOwnProperty('linkId')) {
      webstoreLinkItem.linkId = props.existingWebstoreLink.linkId;
      }
    else if (props.hasOwnProperty('existingWebstoreLink') && props.existingWebstoreLink.hasOwnProperty('couponId')) {
      webstoreLinkItem.linkId = props.existingWebstoreLink.couponId;
    }
    props.handleSubmitButtonPress(webstoreLinkItem);
  };

  return (
    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block', zIndex: 20000, width : '100%', height : '100%' }}>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%', height : '100%', backgroundColor : 'black', opacity : 0.5 }}></div>
      <div style={{ position : 'absolute', top : 0, bottom : 0, left : 0, right : 0, width : '100%' }}>
      <div className="modal-dialog modal-lg" role="document" style={{ width : '80%', backgroundColor : 'white', height : { windowHeight }, maxHeight : { windowHeight } }}>
        { isImageCropModalVisible ? (
          <ImageCropModal aspect={ props.imageAspect } imgsrc={ cropImage } handleCancelPress={ () => { setIsImageCropModalVisible(false); }} handleImageCropCompletedEvent = { (croppedImageUrl) => { handleSubmitImageCropCompletedEvent(croppedImageUrl); }} />
        ) : null }
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{ props.modalTitle }</h5>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick = { props.handleCancelPress }
              onPress = { props.handleCancelPress }>
            </button> 
          </div>
          <div className="modal-body">
        
            { props.isRefreshing ? (
              <Refreshing message={ refreshingMessage } />
            ) : (
              <>
              <div style={{ overflowY : 'scroll', height : '100%', display : 'flex', flexDirection : 'column', flexGrow : 10 }}>
                <table>
                  <tr>
                    <td style={{ paddingLeft: 20}}>{ props.modalKeyword } Name: *</td>
                    <td>
                      <input type='text' placeholder={ props.modalKeyword+' Name ' } value={ webstoreLinkName } onChange = { (event) => { setWebstoreLinkName(event.target.value); }} />
                    </td>
                  </tr>
                  { props.hasOwnProperty('isDisplayText') && props.isDisplayText ? (
                    <tr>
                      <td style={{ paddingLeft: 20}}>{ props.modalKeyword } Display Text:</td>
                      <td>
                        <input type='text' placeholder={ props.modalKeyword+' Display Text' } value={ webstoreLinkDisplayText } onChange = { (event) => { setWebstoreLinkDisplayText(event.target.value); }} />
                      </td>
                    </tr>
                  ) : null }


                  { props.isLinkUrl ? (
                    <tr>
                      <td style={{ paddingLeft: 20}}>{ props.modalKeyword } Url:</td>
                      <td>
                        <input type='text' placeholder={ props.modalKeyword + ' Url' } value={ webstoreLinkLinkUrl } onChange = { (event) => { setWebstoreLinkLinkUrl(event.target.value); }} />
                      </td>
                    </tr>
                  ) : null }
                  <tr>
                    <td style={{ paddingLeft: 20}}>Image:</td>
                    <td style={{ display : 'flex', justifyContent : 'flex-start' }}>
                      <ImageUploading
                        value={images}
                        onChange={onImageChange}
                        maxNumber={ 1 }
                        dataURLKey="data_url"
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                        }) => (
                          // write your building UI
                          <div className="upload__image-wrapper">
                            { (imageList.length == 0) ? (
                              <>
                              {/**
                              <button
                                style={isDragging ? { color: 'red' } : undefined}
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Click or Drop here
                              </button>
                              **/}

                              <div>
                                <div style={{ borderRadius: 10, overflow : 'hidden', backgroundColor : '#e0e0e0' }}>
                                  <div style={{ width : 210, height : 130 }} onClick={ onImageUpload } {...dragProps} >
                                    <MdOutlineAddPhotoAlternate style={{ width : '100%', height : '100%', paddingLeft : 10, paddingRight : 10, color : '#039be5' }}/>
                                  </div>
                                </div>
                                <div style={{ width : '100%', justifyContent : 'center', display : 'flex', fontSize: 12 }}>Drag or Upload Image</div>
                                <div style={{ marginTop : 10, width : '100%', justifyContent : 'center', display : 'flex' }}>
                                  <a className="waves-effect waves-light btn-small blue" onClick={ onImageUpload } >Upload</a>
                                </div>
                              </div>
                                
                                
                              </>
                            ) : null }
                            {/**
                            <button onClick={onImageRemoveAll}>Remove all images</button>
                            **/}
                            {imageList.map((image, index) => (
                              <div key={index} className="image-item">
                                <img src={image['data_url']} alt="" width="100" />
                                <div className="image-item__btn-wrapper">
                                  {/**
                                  <a className="waves-effect waves-light btn-small blue" onClick={() => onImageUpdate(index)}>Update</a>
                                  **/}
                                  <a className="waves-effect waves-light btn-small blue" onClick={() => onImageRemove(index)}>Remove</a>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </ImageUploading>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingLeft: 20}}>Display From:</td>
                    <td>
                      <DatePicker selected={displayFrom} onChange={(date) => setDisplayFrom(date)} dateFormat="dd/MM/yyyy" />
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingLeft: 20}}>Display To:</td>
                    <td>
                      <DatePicker selected={displayTo} onChange={(date) => setDisplayTo(date)} dateFormat="dd/MM/yyyy" />
                    </td>
                  </tr>
                </table>
              </div>
              </>
              ) }
            </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
              onClick={ props.handleCancelPress }
              onPress={ props.handleCancelPress }>Cancel</button>
            { (webstoreLinkName.trim() == '' || images.length == 0 || (props.isLinkUrl && (webstoreLinkLinkUrl.indexOf('//') == -1 || webstoreLinkLinkUrl.indexOf('.') == -1))) ? (
              <button disabled type="button" className="btn btn-primary disabled" style={{ backgroundColor : '#cccccc', borderColor : '#aaaaaa' }} aria-disabled="true">{ props.submitButtonText }</button>
            ) : (
              <button
                  type="button"
                  className="btn btn-primary"
                  onClick={ handleSubmitButtonPress }
                  onPress={ handleSubmitButtonPress }
                >{ props.submitButtonText }</button>
            ) }
          </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default WebstoreLinkAddOrEditModal;
